// ContactList.jsx
import { useState, useEffect, useRef } from "react";
import Sidebar from "../../DesignSystem/Sidebar";
import { Helmet } from "react-helmet-async";
import "../../../css/AdviserSupport/ContactList/ContactList.css";
import { subscribeContactListData } from "./HelperFunctions/FetchContactListData";
import ButtonYellow from "../../DesignSystem/Buttons/ButtonYellow";
import { useNavigate } from "react-router-dom";
import { pdf } from "@react-pdf/renderer"; // <-- add
import { saveAs } from "file-saver"; // <-- add
import { ContactListGenerator } from "./Components/PDF/ContactListGenerator"; // <-- ensure path
import Modal from "./Components/PDF/PdfModal";
// import { saveAs } from "file-saver";
import { exportContactListToExcel } from "./Components/Excel/ContactListExcelGenerator";
import { CATS } from "./HelperFunctions/GetAdviserCategories";
import { filterAdvisersByCats } from "./HelperFunctions/categoryFilters";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";
import { useUserPermissions } from "../../SignIn/UserPermissionsContext";
import PrimaryButton from "../../DesignSystem/Buttons/PrimaryButton";
import SecondaryButton from "../../DesignSystem/Buttons/SecondaryButton";


const ContactList = () => {
  const [advisers, setAdvisers] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [downloadingXlsx, setDownloadingXlsx] = useState(false);
  // PREVIEW state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const previewBlobRef = useRef(null);

  const { userPermissions = [] } = useUserPermissions();
  const navigate = useNavigate();

  const [selectedCats, setSelectedCats] = useState([]); // strings from CATS

  const toggleCat = (cat) => {
    setSelectedCats((prev) =>
      prev.includes(cat) ? prev.filter((x) => x !== cat) : [...prev, cat]
    );
  };

  const clearCats = () => setSelectedCats([]);

  useEffect(() => {
    //  console.log("User Permissions:", userPermissions);
    const isHolidayOnlyUser = [
      "In House Advisers",
      "Holiday Only",
      "Staff Holidays",
    ].some((permission) => userPermissions.includes(permission));

    if (isHolidayOnlyUser) {
      navigate("/Department/AllStaff");
    }
  }, [navigate, userPermissions]);

  useEffect(() => {
    return subscribeContactListData(
      (data) => setAdvisers(data || []),
      () => setAdvisers([]),
    );
  }, []);

  // useEffect(() => {
  //   // Live listener
  //   const unsubscribe = exportAdvisersData(["Personal Details"], (data) => {
  //     setAdvisers(data || []);
  //   });
  //   return () => unsubscribe();
  // }, []);

 const handleDownload = async () => {
   setDownloading(true);
   try {
       const all = advisers || [];
       const isAllDownload = !selectedCats?.length;
       const filtered = filterAdvisersByCats(all, selectedCats);

       const doc = (
         <ContactListGenerator
           contacts={filtered}
           generatedBy="ContactList Page"
           showSummary={isAllDownload}
         />
       );

       const blob = await pdf(doc).toBlob();
       saveAs(
         blob,
         "Contact List - " + new Date().toLocaleDateString() + ".pdf"
       );
   } catch (err) {
   } finally {
     setDownloading(false);
   }
 };


 // ...

 const handleDownloadExcel = async () => {
   setDownloadingXlsx(true);
   try {
       const all = advisers || [];

       const filtered = filterAdvisersByCats(all, selectedCats);
       const isAllDownload = !selectedCats?.length; //  key rule

       const { blob, filename } = await exportContactListToExcel({
         contacts: filtered,
         generatedBy: "ContactList Page",
         includeSummary: isAllDownload, //  only when all advisers
       });

       saveAs(blob, filename);
   } finally {
     setDownloadingXlsx(false);
   }
 };



  // ----- Preview -----
  const handlePreview = async () => {
    setPreviewLoading(true);
    try {
        const isAllDownload = !selectedCats?.length;
        const filtered = filterAdvisersByCats(advisers || [], selectedCats);
        // build the PDF
        const doc = (
          <ContactListGenerator
            contacts={filtered}
            generatedBy="ContactList Page"
            showSummary={isAllDownload}
          />
        );
        const blob = await pdf(doc).toBlob();

        // clean up any previous object URL
        if (previewBlobRef.current) URL.revokeObjectURL(previewBlobRef.current);
        const url = URL.createObjectURL(blob);
        previewBlobRef.current = url;

        setPreviewUrl(url);
        setPreviewOpen(true);
    } catch (err) {
      // console.error("Error generating preview:", err);
    } finally {
      setPreviewLoading(false);
    }
  };

  const closePreview = () => {
    setPreviewOpen(false);
    if (previewBlobRef.current) {
      URL.revokeObjectURL(previewBlobRef.current);
      previewBlobRef.current = null;
    }
    setPreviewUrl(null);
  };

  return (
    <div className="Main-Page">
      <Helmet>
        <title>Contact List</title>
        <meta
          name="description"
          content="Export the Rosemount Contact List PDF."
        />
      </Helmet>

      <Sidebar />

      <div className="Main-Container">
        <div className="Contact-List-Container">
          <Breadcrumb
            items={[
              {
                label: "All Staff",
                to: "/Department/AllStaff",
              },
              { label: "Contact List" },
            ]}
          />
          <h3 className="FP_H3">Contact List</h3>
          {/* <div className="Content-Small FP_Help_Text" >
            IMPORTANT: This document is for internal review only and should not
            be shared outside Rosemount.
          </div > */}
          <div className="clFilters">
            <div className="clFiltersRow">
              {CATS.map((cat) => {
                const active = selectedCats.includes(cat);
                return (
                  <label
                    key={cat}
                    className={`Content clFilterPill ${
                      active ? "isActive" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={active}
                      onChange={() => toggleCat(cat)}
                    />
                    <span className="Content">{cat}</span>
                  </label>
                );
              })}

              <button
                type="button"
                onClick={clearCats}
                className="clClearBtn Content"
              >
                Clear
              </button>
            </div>

            <div className="clFiltersHint FP_Content_Semibold">
              {selectedCats.length
                ? `Downloading only: ${selectedCats.join(", ")}`
                : "No filters selected - downloading details for all advisers."}
            </div>
          </div>

          <div style={{ display: "flex", gap: 12 }}>
            {/* <ButtonYellow
              buttonText={previewLoading ? "Downloading…" : "Preview"}
              onClick={handlePreview}
              disabled={previewLoading}
            /> */}

            <PrimaryButton
              label={downloadingXlsx ? "Downloading…" : "Download Excel"}
              onClick={handleDownloadExcel}
              disabled={downloadingXlsx || (advisers?.length ?? 0) === 0}
            />
            <SecondaryButton
              label={downloading ? "Downloading…" : "Download PDF"}
              onClick={handleDownload}
              disabled={downloading || (advisers?.length ?? 0) === 0}
            />
          </div>
        </div>
      </div>
      <Modal
        open={previewOpen}
        onClose={closePreview}
        title="Contact List Preview"
      >
        {previewUrl ? (
          <iframe
            title="Contact List PDF Preview"
            src={previewUrl}
            style={{ width: "100%", height: "80vh", border: "none" }}
          />
        ) : (
          <div style={{ padding: 16 }}>Generating preview…</div>
        )}
      </Modal>
    </div>
  );
};

export default ContactList;
